import {Component} from "preact";
import style from "./styles.scss";
import {removeHtmlTags} from "../../../../../../utilities/removeHtmlTags";
import ConfigService from "../../../../../../services/ConfigService";
import ModuleInfoProvider from "../../../../../../services/ModuleInfoProvider";
import {newDate} from "../../../../../../utilities/date";
import {createEvent} from "../../../../../../utilities/create-event";
import SimpleDate from "../../../../../common/date/simple-date";

export default class MessageListItem extends Component {
    static defaultProps = {
        message: {}
    };

    render = (props, state, context) =>  {
        const message = this.props.message;
        const sender = message.sender.name;
        const content = removeHtmlTags(message.content).slice(0, 280).replace(/\W{2,}/g, ' ').trim();
        const date = <SimpleDate date={message.createdAt} />;

        let read = true;
        const reference = ConfigService.userProfile().reference;
        for (const recipient of message.recipients) {
            if (recipient.reference === reference) {
                read = recipient.read;
                break;
            }
        }

        const classes = [
            style.listItemContainer,
            read ? null : style.unread
        ].filter(i => i).join(' ');

        return (
            <a href={this.getMessageUrl()} class={classes} onClick={this.navigateToLink}>
                <div class={style.listItem}>
                    <h4 class={style.itemTitle}>{message.subject}</h4>
                    <div class={style.itemBody}>{content}</div>
                    <div class={style.itemFooter}>
                        <span>{sender}</span>
                        <span>{date}</span>
                    </div>
                </div>
            </a>
        );
    };

    getMessageUrl = () => {
        return ModuleInfoProvider.getModuleBackendUrl('extranet') + '/messages/' + this.props.message.id;
    };

    navigateToLink = (event) => {
        this.base.dispatchEvent(createEvent('closeDropdown', {bubbles:true}));
        event.preventDefault();
        event.stopPropagation();
        ConfigService.navigateFunction(this.getMessageUrl());
    }
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/messenger/message-list-item/index.js